import { render, staticRenderFns } from "./GardenbaikaRirekishoPreview.vue?vue&type=template&id=3a5c20e9&"
import script from "./GardenbaikaRirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./GardenbaikaRirekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports